export class PermissionsUtils {
    static isAccessible = (permission: string, permissions: string[]): boolean =>
        permissions.some((p) => p === permission);
}
